module.exports = __webpack_public_path__ + "img/career_ceping47.02f77ea9.jpg";